<template>
  <form
    class="sm:grid sm:grid-cols-3 mt-10"
    @submit.prevent="deleteAccount">
    <div class="col-span-1">
      <h2 class="text-lg sm:text-right">看護学校との連携</h2>
    </div>
    <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
      <jet-label
        v-if="!isLinked"
        for="code"
        class="mt-4 sm:mt-0"
        value="連携用コード" />
      <jet-input
        v-if="!isLinked"
        id="code"
        v-model="code"
        :disabled="!user.is_input_school_info"
        type="text"
        class="mt-1 mr-4 w-40"
        autocomplete="off" />
      <span v-if="isLinked">
        学校名：{{ schoolName }}
      </span>
      <button
        class="bg-white text-CLIENT_PRIMARY_PINK text-center border-2 border-CLIENT_PRIMARY_PINK text-base rounded-xl px-2 py-2 mt-4 sm:ml-12 sm:mt-0 hover:bg-gray-100 duration-500 disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="!code"
        @click="onClick">
        {{ isLinked ? '連携済み' : '看護学校と連携する' }}
      </button>
    </div>
    <div class="col-span-1"></div>
    <div
      v-if="!user.is_input_school_info"
      class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16">
      <Link
        :href="route('client.profile.show')"
        class="underline text-blue-700">
        ※先にこちらから学生情報を入力してください。
      </Link>
    </div>
  </form>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import Swal from 'sweetalert2'
import { usePage, Link } from '@inertiajs/inertia-vue3'
import JetInput from '@/Jetstream/Input'
import JetLabel from '@/Jetstream/Label'

const code = ref('')
const isProcessing = ref(false)

const props = defineProps({
  schoolName: {
    type: String,
    default: () => '',
  },
})

const { user } = usePage().props.value.client
const isFirstLink = user.is_first_link_school

const isLinked = !!user.linked_school_id

const onClick = () => {
  if (isProcessing.value) return
  isProcessing.value = true

  if (!user.is_input_school_info) {
    showRequiredSchoolInputModal()
    return
  }
  link()
}

const showRequiredSchoolInputModal = () => {
  Swal.fire({
    icon: 'warning',
    title: '学生情報を入力してください',
    text: 'プロフィール変更画面の学生情報にチェックを入れて情報を入力してください',
    showCancelButton: true,
    confirmButtonText: '進む',
    cancelButtonText: '戻る',
  }).then((result) => {
    if (result.isConfirmed) {
      Inertia.get(route('client.profile.show'))
      isProcessing.value = false
    }
  })
  isProcessing.value = false
}

const link = () => {
  Swal.fire({
    icon: 'question',
    title: '連携しますか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then((result) => {
    if (result.isConfirmed) {
      Inertia.visit(route('clients.credential.link-school'), {
        method: 'post',
        data: {
          link_code: code.value,
        },
        onSuccess: () => {
          if (!isFirstLink) {
            Swal.fire({
              icon: 'success',
              title: '模試が受験できるようになりました。',
              text: '既に付与対象の模試を購入されている場合はチケットが付与されています。',
            })
          }
        },
      })
    }
  })
  isProcessing.value = false
}

</script>
